import * as yup from 'yup'
import { t } from 'i18next'

/**
 * Form constants
 */

// Section 1
const TEXT = 'text'
const IS_SHOWN_TO_STUDENTS = 'is_shown_to_students'

/**
 * Form model
 */
const formModel = () => {
  return {
    [TEXT]: {
      label: `${t('common.text')}`,
      name: TEXT,
      required: true,
    },
    [IS_SHOWN_TO_STUDENTS]: {
      label: `${t('common.is-shown-to-students')}`,
      name: IS_SHOWN_TO_STUDENTS,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [TEXT]: '',
  [IS_SHOWN_TO_STUDENTS]: true
}
/**
 * Form data validation
 */
 export const validationSchema = () =>
 yup.object().shape({
     [TEXT]: yup.string().required(`${t('errors.required-error-message')}`),
 })

export default formModel
